import { Box } from "@mui/material";
import { ModuleGameStatus, SelectedGame } from "entities/modules/types";
import { useState } from "react";
import { COLOR_GREY_8 } from "shared/theme/colors";
import { EyeOffIcon } from "shared/theme/icons/EyeOffIcon";
import { EyeOnIcon } from "shared/theme/icons/EyeOnIcon";
import DragNDropTable from "../DragNDropTable";
import { StyledStatus } from "./styled";

type Props = {
  selectedGames: SelectedGame[];
  setSelectedGames: (games: SelectedGame[]) => void;
  isLoadingSelectedGamesList: boolean;
};

const ManualSelectedGamesList = ({
  isLoadingSelectedGamesList,
  selectedGames,
  setSelectedGames,
}: Props) => {
  const [hoveredRowId, setHoveredRowId] = useState<string>();

  const toggleGameStatus = (gameId: string) => {
    setSelectedGames(
      selectedGames.map((game) => {
        if (game.id === gameId) {
          const newStatus =
            game.status === ModuleGameStatus.Active
              ? ModuleGameStatus.Hidden
              : ModuleGameStatus.Active;
          return { ...game, status: newStatus };
        }
        return game;
      }),
    );
  };

  return (
    <Box mt="1rem">
      <DragNDropTable<SelectedGame>
        items={selectedGames || []}
        columns={[
          {
            headerName: "Name",
            width: "40%",
            headerPadding: "0.75rem",
            renderCell: (item: SelectedGame) => item.name,
          },
          {
            headerName: "Studio",
            width: "40%",
            headerPadding: "0.75rem",
            renderCell: (item: SelectedGame) => item.studioName ?? "-",
          },
          {
            headerName: "Visibility",
            width: "20%",
            headerPadding: "0.75rem",
            renderCell: (item: SelectedGame) => {
              const isHidden = item.status === ModuleGameStatus.Hidden;
              const isRowHovered = hoveredRowId === item.id;

              return (
                <StyledStatus
                  isHovered={isRowHovered || isHidden}
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleGameStatus(item.id);
                  }}
                >
                  {isHidden ? (
                    <EyeOffIcon color={COLOR_GREY_8} />
                  ) : (
                    <EyeOnIcon color={COLOR_GREY_8} />
                  )}
                </StyledStatus>
              );
            },
          },
        ]}
        isItemsFetched={!isLoadingSelectedGamesList}
        isItemsLoading={isLoadingSelectedGamesList}
        noItemsMessage="No games found"
        onItemsReorder={async (games) => {
          setSelectedGames(
            games.map((game, index) => ({
              ...game,
              order: index + 1,
            })),
          );
        }}
        getRowOpacity={(game) =>
          game.status === ModuleGameStatus.Hidden ? 0.4 : 1
        }
        onRowMouseEnter={(item) => setHoveredRowId(item.id)}
        onRowMouseLeave={() => setHoveredRowId("")}
      />
    </Box>
  );
};

export default ManualSelectedGamesList;
